import { Fragment, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { t } from '@/lib/i18n';

const segmentLabels: Record<string, string> = {
  '': t('nav.dashboard'),
  keys: t('nav.inventory'),
  shipments: t('nav.shipments'),
  sales: t('nav.sales'),
  partners: t('nav.partners'),
  suppliers: t('nav.suppliers'),
  tools: t('nav.tools'),
  reports: t('nav.reports'),
  settings: t('nav.settings'),
  new: t('action.add'),
  edit: t('action.edit'),
};

export function Breadcrumbs() {
  const location = useLocation();

  const crumbs = useMemo(() => {
    const parts = location.pathname.split('/').filter(Boolean);
    const list = [{ to: '/', label: t('nav.dashboard'), home: true }];
    let acc = '';
    for (const p of parts) {
      acc += `/${p}`;
      list.push({
        to: acc,
        label: segmentLabels[p] ?? (Number.isFinite(Number(p)) ? `#${p}` : p),
        home: false,
      });
    }
    return list;
  }, [location.pathname]);

  if (crumbs.length <= 1) return null;

  return (
    <nav aria-label="breadcrumb" className="flex items-center gap-1 text-xs text-muted-foreground">
      {crumbs.map((c, idx) => {
        const last = idx === crumbs.length - 1;
        return (
          <Fragment key={c.to}>
            {idx > 0 ? <ChevronRight className="h-3 w-3 opacity-60" /> : null}
            {last ? (
              <span className="font-medium text-foreground">
                {c.home ? <Home className="inline h-3 w-3" /> : c.label}
              </span>
            ) : (
              <Link to={c.to} className="hover:text-foreground">
                {c.home ? <Home className="inline h-3 w-3" /> : c.label}
              </Link>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
}
